import React, { FC, useState, Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, Filter, ChevronDown, RefreshCw } from "lucide-react";
import { NO_DATA } from "../../../assets";
import TableComponent from "../../../shared/components/table";
import { Registrar1PaymentColumns } from "../../../shared/components/table/columns/registrar1Payment";
import { SortingState } from "@tanstack/react-table";
import { Menu, Transition } from "@headlessui/react";

import CaseFolderDetailsModal from "./case-folder/modals/CaseFolderDetailsModal";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  openCaseModal,
  setCaseDetailModal,
  selectSubmitModal,
  setSubmitModal,
  selectShowAppealModal,
  setAppealModal,
} from "../../../states/slices/globalReducer";
import SubmitTransferModal from "./case-folder/modals/SubmitTransferModal";
import SuccessModalV2 from "../../../shared/components/successModal/sucessModalV2";
import ModalV2 from "../../../shared/components/modalV2";
import { Registrar2CaseFolderColumns } from "../../../shared/components/table/columns/registrar2CaseFolderColumn";

const filterOptions = ["All cases", "Pending cases", "Completed cases"];

const CaseFolders: FC = () => {
  const [hasData, setHasData] = useState(true);
  const navigate = useNavigate();
  const [submittedSuccessModal, setSubmittedSuccessModal] = useState(false);
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const showCaseFolderDetails = useAppSelector(openCaseModal);
  const showSubmitModal = useAppSelector(selectSubmitModal);
  const dispatch = useAppDispatch();
  const [activeFilter, setActiveFilter] = useState("All cases");
  const showAppealModal = useAppSelector(selectShowAppealModal);
  const handleSubmit = () => {
    dispatch(setSubmitModal(false));
    // Add logic here
    setSubmittedSuccessModal(true);
  };

  const mockData = [
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      details: "View",
      query_status: "",
      payment: "Successful",
      verify_payment: true,
      assigned_registrar: "Mr. Mical Doe",
      time_spent: "72 hrs",
      appeal_number: "",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      details: "View",
      query_status: "",
      payment: "",
      verify_payment: false,
      assigned_registrar: "Mr. Mical Doe",
      time_spent: "",
      appeal_number: "",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      details: "View",
      query_status: "",
      payment: "",
      verify_payment: false,
      assigned_registrar: "Mr. Mical Doe",
      time_spent: "",
      appeal_number: "",
    },
  ];

  return (
    <div className="flex flex-col h-full  min-h-screen">
      {/* Header */}
      <div className="bg-white px-8 py-6 border-b border-[#E9EAEB] flex items-center justify-between">
        <h1 className="text-2xl font-bold text-[#1A1A1A]">
          Case folder history
        </h1>
        <div className="flex items-center gap-x-4">
          <Menu as="div" className="relative inline-block text-left">
            <Menu.Button className="flex items-center gap-x-2 border border-[#E9EAEB] px-4 py-2 rounded-lg text-sm font-medium text-[#344054] hover:bg-gray-50 transition-colors bg-white shadow-sm">
              <Filter className="w-4 h-4" />
              <span>{activeFilter}</span>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
                <div className="py-1">
                  {filterOptions.map((option) => (
                    <Menu.Item key={option}>
                      {({ active }) => (
                        <button
                          onClick={() => setActiveFilter(option)}
                          className={`${
                            active
                              ? "bg-[#D1FADF] text-[#027A48]"
                              : "text-[#1A1A1A]"
                          } group flex w-full items-center px-4 py-2.5 text-sm`}
                        >
                          {option}
                        </button>
                      )}
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>

      {/* Breadcrumb & Search */}
      <div className="px-8 py-4 flex flex-col gap-y-6">
        <div className="flex items-center gap-x-2 text-sm text-[#464255]">
          <Link to="/lawyer/overview" className="hover:text-[#00B074]">
            Home
          </Link>
          <span>&gt;</span>
          <span className="font-medium text-[#1A1A1A]">
            Case folder history
          </span>
        </div>

        <div className="relative w-full max-w-[300px]">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#E9EAEB] focus:outline-none focus:border-[#00B074] bg-white text-sm"
          />
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9A9A9A]" />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 px-8 pb-8">
        {hasData ? (
          // List State
          <div className="bg-white rounded-xl ">
            <TableComponent
              DATA={mockData}
              // @ts-ignore
              COLUMNS={Registrar2CaseFolderColumns}
              sorting={sorting}
              setSorting={setSorting}
            />

            {/* Pagination Mockup */}
            <div className="flex items-center justify-end gap-x-4 mt-6 text-sm text-[#464255]">
              <span>Page 1 of 10</span>
              <div className="flex items-center gap-x-2">
                <button className="px-3 py-1.5 border border-[#E9EAEB] rounded hover:bg-gray-50">
                  Previous
                </button>
                <button className="px-3 py-1.5 border border-[#E9EAEB] rounded hover:bg-gray-50">
                  Next
                </button>
              </div>
              <div className="flex items-center gap-x-2">
                <span>Entries per page:</span>
                <select className="border border-[#E9EAEB] rounded p-1 focus:outline-none">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                </select>
              </div>
            </div>
          </div>
        ) : (
          // Empty State
          <div className="flex flex-col items-center justify-center h-[60vh] gap-y-2">
            <img src={NO_DATA} alt="No Data" className="w-[200px] h-[200px]" />
            <span className="text-[#464255] font-medium text-lg">
              No case folders found
            </span>
          </div>
        )}
      </div>

      <CaseFolderDetailsModal
        open={showCaseFolderDetails || false}
        close={() => dispatch(setCaseDetailModal(false))}
      />
      <SubmitTransferModal
        isOpen={showSubmitModal || false}
        onClose={() => dispatch(setSubmitModal(false))}
        onClick={handleSubmit}
      />
      <SuccessModalV2
        open={submittedSuccessModal}
        close={() => setSubmittedSuccessModal(false)}
        message="Submitted and transferred"
      />
      <ModalV2
        isOpen={showAppealModal || false}
        isClose={() => dispatch(setAppealModal(false))}
        maxWidth="w-[500px]"
        edges="rounded-xl"
      >
        <div className="flex flex-col gap-6 p-6 w-full">
          <h2 className="text-xl font-bold text-center text-[#1A1A1A]">
            Assign appeal number
          </h2>

          <div className="flex flex-col gap-4 w-full">
            <div className="relative w-full">
              <select className="w-full px-4 py-3 border border-[#E9EAEB] rounded-lg appearance-none bg-white text-[#464255] focus:outline-none focus:border-[#00B074] cursor-pointer">
                <option value="" disabled selected>
                  Case Category
                </option>
                <option value="civil">Civil</option>
                <option value="criminal">Criminal</option>
              </select>
              <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9A9A9A] pointer-events-none" />
            </div>

            <div className="flex flex-col gap-1 w-full">
              <div className="relative w-full">
                <div className="w-full px-4 py-3 border border-[#E9EAEB] rounded-lg bg-white text-[#1A1A1A] flex items-center justify-between">
                  <span>Recent Appeal Number</span>
                  <RefreshCw className="w-5 h-5 text-[#1A1A1A] cursor-pointer" />
                </div>
              </div>
              <span className="text-xs text-[#9A9A9A] text-left">
                Last Used Appeal number
              </span>
            </div>

            <input
              type="text"
              placeholder="Input appeal number"
              className="w-full px-4 py-3 border border-[#E9EAEB] rounded-lg focus:outline-none focus:border-[#00B074] placeholder-[#9A9A9A]"
            />
          </div>

          <button className="w-full bg-[#00B074] text-white py-3 rounded-lg font-medium hover:bg-[#009060] transition-colors mt-2">
            Assign appeal number
          </button>
        </div>
      </ModalV2>
    </div>
  );
};

export default CaseFolders;
